import { PortableTextBlock } from 'sanity'

import { Column, Grid } from '~/components/Grid'
import PageTitle from '~/components/PageTitle'
import { SecondaryPage } from '~/lib/sanity.queries'

import Radar from './Radar'

export default function Hero({ content }: { content: SecondaryPage['hero'] }) {
  return (
    <div className="flex flex-col items-start justify-center p-0 px-4 pt-header-lg overflow-hidden relative mb-16 md:mb-20">
      <PageTitle title={content.title as PortableTextBlock[]} />
      <Grid>
        <Column className="col-span-12 md:col-span-10 md:col-start-2">
          <div className="flex flex-col items-start justify-center z-10 w-full mt-4 md:mt-10">
            <div className="text-center w-full">
              <div className="flex items-center justify-center w-96 m-auto max-w-full">
                <Radar />
              </div>
            </div>
          </div>
        </Column>
      </Grid>
    </div>
  )
}
